import {
  ReadyExperimentValue,
  UndefinedExperimentValue
} from '@/global/store/useExperimentStore'
import { createContext, RefObject } from 'react'
import { StepState } from '@/modules/simulator/hooks/useStepReducer/useStepReducer'
import { SimulationState } from '@/modules/simulator/hooks/useSimulationReducer/useSimulationReducer'

interface SimulatorContextProps {
  simulatorVersion: ReadyExperimentValue | UndefinedExperimentValue
  step: StepState
  simulation: SimulationState
  simulatorWrapperRef: RefObject<HTMLDivElement | null> | null
}

const SimulatorContext = createContext<SimulatorContextProps>({
  simulatorVersion: { isReady: false, value: undefined },
  step: { steps: 0, currentStep: 0 },
  simulation: {
    id: '',
    answers: {},
    isReaccessingMESimulation: false
  },
  simulatorWrapperRef: null
})

export type { SimulatorContextProps }

export { SimulatorContext }
